import React from 'react';

const Banner: React.FC = ({ children }) => (
  <div className="relative z-10 pdt-15x pdb-15x fsz-md fw-bold white bgc-terracotta ta-center">
    {children}
  </div>
);

export default Banner;
